import { render, staticRenderFns } from "./MultiColumnLedger.vue?vue&type=template&id=5984ff77&scoped=true"
import script from "./MultiColumnLedger.vue?vue&type=script&lang=js"
export * from "./MultiColumnLedger.vue?vue&type=script&lang=js"
import style0 from "./MultiColumnLedger.vue?vue&type=style&index=0&id=5984ff77&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984ff77",
  null
  
)

export default component.exports